// THE GROUND PREP SLOT (quest-move 2026-11-02): how ClientGround (ground.js)
// gets a landed GM03 node indexed off the main thread without importing the
// pool — ClientGround's bundle stays its own closure (check-server-ground:
// samplers only in the named spans). pool.js registers its runner here
// (bytes -> Promise of the node's GMIX1 index, op ground.index →
// pool-ground.js); nothing registered = the synchronous add.
let _prep = null;

export function setGroundPrep(fn) { _prep = typeof fn === 'function' ? fn : null; }
export function groundPrep() { return _prep; }
